import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { BadImplementationException } from '@nu-art/ts-common';
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
export class TS_ComponentTransition extends ComponentSync {
    static defaultProps = {
        unmountTimeout: 0,
        mountTimeout: 0,
    };
    shouldReDeriveState(nextProps) {
        return this.props?.trigger !== nextProps.trigger;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        //First load
        if (!state.transitionPhase)
            state.transitionPhase = nextProps.trigger
                ? nextProps.skipAnimationOnMount ? 'enter-done' : 'mount'
                : 'unmount';
        //Triggered change
        else
            state.transitionPhase = nextProps.trigger ? 'mount' : 'exit';
        return state;
    }
    triggerNextTimeout = () => {
        switch (this.state.transitionPhase) {
            case 'mount':
                setTimeout(() => {
                    this.setState({ transitionPhase: 'enter' });
                }, this.props.mountTimeout);
                break;
            case 'enter':
                setTimeout(() => {
                    this.setState({ transitionPhase: 'enter-done' });
                    this.props.onEnterDone?.();
                }, this.props.transitionTimeout);
                break;
            case 'exit':
                setTimeout(() => {
                    this.setState({ transitionPhase: 'exit-done' });
                }, this.props.transitionTimeout);
                break;
            case 'exit-done':
                setTimeout(() => {
                    this.setState({ transitionPhase: 'unmount' });
                }, this.props.unmountTimeout);
        }
    };
    render() {
        this.triggerNextTimeout();
        if (this.state.transitionPhase === 'unmount')
            return '';
        if (!this.props.children)
            throw new BadImplementationException('Component Expects at least one child');
        return _jsx(_Fragment, { children: React.Children.map(this.props.children, child => {
                return React.cloneElement(child, {
                    className: _className(child.props.className, this.props.transitionPrefix ? `${this.props.transitionPrefix}-${this.state.transitionPhase}` : this.state.transitionPhase),
                    style: { transitionDuration: `${this.props.transitionTimeout}ms` }
                });
            }) });
    }
}
//# sourceMappingURL=TS_ComponentTransition.js.map